import { render } from "./Mechanics.vue?vue&type=template&id=171b004a"
import script from "./Mechanics.vue?vue&type=script&lang=js"
export * from "./Mechanics.vue?vue&type=script&lang=js"
script.render = render

export default script